export default "__VITE_ASSET__34ae7bdc__"